import { Box, Container, Flex, Image, Link, Text } from "@chakra-ui/react";
import { Input } from "components";
import { useState } from "react";
import { AiOutlineCheck, AiOutlineStar } from "react-icons/ai";
import { MdHouse, MdLanguage } from "react-icons/md";
import { RiPencilLine } from "react-icons/ri";

const PersonalInfo = () => {
  const [editPersonalInfo, setEditPersonalInfo] = useState(false);
  const [editAbout, setEditAbout] = useState(false);
  const getColor = () => (editPersonalInfo || editAbout) && '#A3A3A3'

  return (
    <Container >
    <Box border="1px solid #E9EEF1" borderRadius="50px"  padding={10}>
      <Flex align="center" >
        <Box position="relative" width="25%">
          <Image src="https://bit.ly/sage-adebayo" borderRadius='100px' width='128px' height='128px' />
          <Flex  backgroundColor="#3498FE" width={4} height={4} align="center" borderRadius="100px" position="absolute" right="25%" bottom="2%" cursor="pointer">
            <RiPencilLine color="white" />
          </Flex>
        </Box>
        <Flex flexDirection="column" marginLeft={10}>
          <Text fontSize="32px" fontWeight={700}>Hello, I'm Noel</Text>
          <Text color="#6F6F6F" fontWeight={400} fontSize="12px">Since 2019</Text>
          <Flex align="center">
            <AiOutlineStar />
            <Text marginLeft={3} fontWeight={600} fontSize="20px">2 Reviews</Text>
          </Flex>
        </Flex>
      </Flex>
      <Flex justifyContent='space-between' marginTop={10} marginBottom={5} align='center'>
            <Text fontWeight={700} color={!editPersonalInfo ? getColor() || '' : ''} fontSize='26px'>Noel, your identity is confirmed</Text>
            <Link fontWeight={600} color={!editPersonalInfo ? getColor() || '' : ''} fontSize='16px' onClick={() => setEditPersonalInfo(!editPersonalInfo)}>{editPersonalInfo ? 'Save':'Edit'}</Link>
      </Flex>
      <Flex align='center'>
        <AiOutlineCheck color="#90D933" size="40px" />
        <Input defaultValue="Noel" disabled={!editPersonalInfo} variant="filled" marginRight={5} />
        <Input defaultValue="Noel" disabled={!editPersonalInfo} variant="filled" />
      </Flex>
      <Flex align='center' marginTop={5}>
        <AiOutlineCheck color="#90D933" size="20px" />
        <Input defaultValue="X-9532465L" disabled={!editPersonalInfo} variant="filled" />
      </Flex>
      <Flex align='center'marginTop={5}>
        <AiOutlineCheck color="#90D933" size="20px" />
        <Input defaultValue="noel.noel@gmail.com" disabled={!editPersonalInfo} variant="filled" />
      </Flex>
      <Flex align='center'marginTop={5}>
        <AiOutlineCheck color="#90D933" size="20px" />
        <Input defaultValue="+31 265 256 865" disabled={!editPersonalInfo} variant="filled" />
      </Flex>
      <Flex marginTop={5}>
        <Input defaultValue="Male" disabled={!editPersonalInfo} variant="filled" />
      </Flex>
      </Box>
      <Box marginTop={10} border="1px solid #E9EEF1" borderRadius="50px"  padding={10}>
        <Flex justifyContent='space-between' marginTop={10} marginBottom={5} align='center'>
              <Text fontWeight={700} color={!editAbout ? getColor() || '' : ''} fontSize='26px'>About</Text>
              <Link fontWeight={600} color={!editAbout ? getColor() || '' : ''} fontSize='16px' onClick={() => setEditAbout(!editAbout)}>{editAbout ? 'Save':'Edit'}</Link>
        </Flex>
        <Text> Hey! My name is Noel,
          I don’t travel that much and usually when I do is with business. 
          I will be out and about most of the time or working on my computer or being on the phone.
        </Text>
        <Flex align="center" marginTop={5}>
          <MdHouse /> 
          <Text  marginLeft={2} fontWeight={500} fontSize="16px">Lives in Tulum, Mexico</Text>
        </Flex>
        <Flex align="center" marginTop={2}>
          <MdLanguage /> 
          <Text  marginLeft={2} fontWeight={500} fontSize="16px">Preferred language English and Spanish</Text>
        </Flex>
      </Box>
    </Container>
  );
};

export { PersonalInfo };
